/***
 * @file: messageæå¡
 * @author: linkun.he
 * @Date: 2020-12-21 14:49:19
 */
import { Injectable, Injector } from '@angular/core';
import { I18NService } from '@ithinkdt/shared/i18n';
import { NzMessageService } from 'ng-zorro-antd/message';

import { MessageDataOptions } from './message.interface';
@Injectable({
  providedIn: 'root',
})
export class DtMessageService {
  constructor(public inj: Injector, private i18NSrv: I18NService, private nzMessageSrv: NzMessageService) {}

  success(title: string, options?: MessageDataOptions) {
    this.nzMessageSrv.success(this.itr(title), options);
  }

  error(title: string, options?: MessageDataOptions) {
    this.nzMessageSrv.error(this.itr(title), options);
  }

  info(title: string, options?: MessageDataOptions) {
    this.nzMessageSrv.info(this.itr(title), options);
  }

  warning(title: string, options?: MessageDataOptions) {
    this.nzMessageSrv.warning(this.itr(title), options);
  }

  loading(title: string, options?: MessageDataOptions) {
    this.nzMessageSrv.loading(this.itr(title), options);
  }

  itr(title: string) {
    return this.i18NSrv.interpret(title);
  }
}
